module.exports = __webpack_public_path__ + "img/bn20.93a17215.png";